import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M16.718 6.22a.75.75 0 0 1 1.06 1.06L13.06 12l4.718 4.719a.75.75 0 0 1-1.06 1.06l-4.719-4.718-4.719 4.718a.75.75 0 1 1-1.06-1.06l4.719-4.719-4.72-4.719A.75.75 0 1 1 7.28 6.22L12 10.939z"
    }, null, -1)
  ]))]))
}
export default { render: render }